export function showPlansAndPricingDropdownInMarketplaceHeader({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.showPlansAndPricingInMarketplaceHeader || (_headerStore$userSpec = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec !== void 0 && _headerStore$userSpec.showPlansAndPricingInMarketplaceHeader);
}
export function showPlansAndPricingFrontendsNavInMarketplaceHeader({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec2;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.showPlansAndPricingPageNavInMarketplaceHeader || (_headerStore$userSpec2 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec2 !== void 0 && _headerStore$userSpec2.showPlansAndPricingPageNavInMarketplaceHeader);
}
export function showCobrandingLogo({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec3;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.showCobrandingLogo || (_headerStore$userSpec3 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec3 !== void 0 && _headerStore$userSpec3.showCobrandingLogo);
}
export function showUserActivityLink({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec4;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.showUserActivityLink || (_headerStore$userSpec4 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec4 !== void 0 && _headerStore$userSpec4.showUserActivityLink);
}
export function isAggregatorEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec5;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isAggregatorEnabled || (_headerStore$userSpec5 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec5 !== void 0 && _headerStore$userSpec5.isAggregatorEnabled);
}
export function isLearnAINavigationEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec6;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isLearnAINavigationEnabled || (_headerStore$userSpec6 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec6 !== void 0 && _headerStore$userSpec6.isLearnAINavigationEnabled);
}

/**
 * True when split categories nav is enabled (Learn AI tab + Find courses tab for MX users).
 * Read from headerExperimentFeatures; used by desktop BrowseNavDropdown and mobile nav.
 */
export function isSplitNavByCategoriesEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec7;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isSplitNavByCategoriesEnabled || (_headerStore$userSpec7 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec7 !== void 0 && _headerStore$userSpec7.isSplitNavByCategoriesEnabled);
}
export function isAcademiesEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec8;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isAcademiesEnabled || (_headerStore$userSpec8 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec8 !== void 0 && _headerStore$userSpec8.isAcademiesEnabled);
}
export function isSearchInputAutoFocusEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec9;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.searchInputMWebAutoFocus || (_headerStore$userSpec9 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec9 !== void 0 && _headerStore$userSpec9.searchInputMWebAutoFocus);
}
export function isRolePlayEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec0;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isRolePlayEnabled || (_headerStore$userSpec0 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec0 !== void 0 && _headerStore$userSpec0.isRolePlayEnabled);
}
export function isAiAssistantEntryPointEnabled({
  headerExperimentFeatures,
  headerStore
}) {
  var _headerStore$userSpec1;
  return !!(headerExperimentFeatures !== null && headerExperimentFeatures !== void 0 && headerExperimentFeatures.isAiAssistantEntryPointEnabledInHeader || (_headerStore$userSpec1 = headerStore.userSpecificContext.headerExperimentFeatures) !== null && _headerStore$userSpec1 !== void 0 && _headerStore$userSpec1.isAiAssistantEntryPointEnabledInHeader);
}
//# sourceMappingURL=header-experiment-features.js.map